<div class="wizard-page" [class.drawer-mode]="drawerMode">
  <nav class="wizard-breadcrumb" *ngIf="!drawerMode">
    <a routerLink="/admin/postos" class="bc-link">Postos</a>
    <ng-container *ngIf="editMode && editPostoId">
      <span class="bc-sep"><i class="fas fa-chevron-right"></i></span>
      <a [routerLink]="['/admin/postos', editPostoId]" class="bc-link">Detalhe</a>
    </ng-container>
    <span class="bc-sep"><i class="fas fa-chevron-right"></i></span>
    <span class="bc-current">{{ editMode ? "Editar Posto" : "Novo Posto" }}</span>
  </nav>

  <div class="wizard-layout">
    <aside class="wizard-rail">
      <div
        class="rail-step"
        *ngFor="let step of steps; let i = index"
        [class.active]="activeStep === i"
        [class.completed]="activeStep > i"
        (click)="goToStep(i)"
      >
        <div class="rail-connector" *ngIf="i > 0">
          <div
            class="connector-fill"
            [style.height.%]="activeStep > i ? 100 : 0"
          ></div>
        </div>

        <div class="rail-node">
          <i class="fas fa-check" *ngIf="activeStep > i"></i>
          <span *ngIf="activeStep <= i">{{ i + 1 }}</span>
        </div>

        <div class="rail-label">
          <span class="step-title">{{ step.title }}</span>
          <span class="step-subtitle">{{ step.subtitle }}</span>
        </div>
      </div>
    </aside>

    <main class="wizard-content">
      <!-- PASSO 0: CLIENTE -->
      <div
        *ngIf="activeStep === 0"
        class="step-panel"
        [formGroup]="clienteForm"
      >
        <div class="step-header">
          <div class="step-icon"><i class="fas fa-building"></i></div>
          <div>
            <h2>Seleccionar Cliente</h2>
            <p>O posto pertence a que cliente?</p>
          </div>
        </div>

        <div class="cliente-fixo-banner" *ngIf="clienteFixo">
          <i class="fas fa-lock"></i>
          <span>Cliente pré-seleccionado. Para alterar, aceda à lista de postos.</span>
        </div>

        <div class="sp-form-group search-group" *ngIf="!clienteFixo">
          <label>Pesquisar cliente *</label>
          <p-autoComplete
            [(ngModel)]="clienteAutocompleteVal"
            [ngModelOptions]="{ standalone: true }"
            [suggestions]="clientesFiltrados"
            (completeMethod)="pesquisarClientes($event)"
            (onSelect)="selecionarCliente($event)"
            (onClear)="limparCliente()"
            optionLabel="nome"
            [minLength]="0"
            placeholder="Nome ou NIF do cliente…"
            styleClass="w-full"
            [dropdown]="true"
            [forceSelection]="true"
            appendTo="body"
          >
            <ng-template let-c pTemplate="item">
              <div class="ac-item">
                <div class="ac-item-icon"><i class="fas fa-building"></i></div>
                <div class="ac-item-info">
                  <span class="ac-nome">{{ c.nome }}</span>
                  <span class="ac-nif" *ngIf="c.nif">NIF: {{ c.nif }}</span>
                  <span class="ac-tel" *ngIf="c.numTelefone">{{ c.numTelefone }}</span>
                </div>
              </div>
            </ng-template>
          </p-autoComplete>
          <span
            class="sp-error"
            *ngIf="
              clienteForm.get('idCliente')?.invalid &&
              clienteForm.get('idCliente')?.touched
            "
          >
            Seleccione um cliente
          </span>
        </div>

        <div class="cliente-card" *ngIf="clienteSelecionado">
          <div class="cliente-card-icon"><i class="fas fa-building"></i></div>
          <div class="cliente-card-info">
            <span class="cliente-nome">{{ clienteSelecionado.nome }}</span>
            <span class="cliente-meta" *ngIf="clienteSelecionado.nif"
              >NIF: {{ clienteSelecionado.nif }}</span
            >
            <span class="cliente-meta" *ngIf="clienteSelecionado.numTelefone">{{
              clienteSelecionado.numTelefone
            }}</span>
          </div>
          <span class="badge-selected"
            ><i class="fas fa-check"></i> Seleccionado</span
          >
        </div>

        <div class="criar-link">
          <a href="/admin/clientes/novo" target="_blank" class="link-text">
             Criar novo cliente
          </a>
        </div>
      </div>

      <!-- PASSO 1: CONTRATO -->
      <div
        *ngIf="activeStep === 1"
        class="step-panel"
        [formGroup]="contratoForm"
      >
        <div class="step-header">
          <div class="step-icon"><i class="fas fa-file-contract"></i></div>
          <div>
            <h2>Associar Contrato</h2>
            <p>
              Contratos de <strong>{{ clienteSelecionado?.nome }}</strong>
            </p>
          </div>
        </div>

        <div *ngIf="loadingContratos" class="loading-hint">
          <i class="fas fa-spinner fa-spin"></i> A carregar contratos…
        </div>

        <div class="contratos-grid" *ngIf="!loadingContratos">
          <div
            class="contrato-card"
            *ngFor="let c of contratos"
            [class.selected]="contratoSelecionado?.id === c.id"
            (click)="selecionarContrato(c)"
          >
            <div
              class="contrato-check"
              *ngIf="contratoSelecionado?.id === c.id"
            >
              <i class="fas fa-check"></i>
            </div>
            <div class="contrato-header">
              <i class="fas fa-file-contract"></i>
              <span class="contrato-id">CONTRATO #{{ c.id }}</span>
            </div>
            <div class="contrato-body">
              <div class="contrato-row">
                <span class="ct-label">Validade</span>
                <span class="ct-value"
                  >{{ fmtDisplay(c.inicioContrato) }} –
                  {{ fmtDisplay(c.fimContrato) }}</span
                >
              </div>
              <div class="contrato-row">
                <span class="ct-label">Valor Mensal</span>
                <span class="ct-value">{{ fmtMoeda(c.valorMensal) }}</span>
              </div>
            </div>
          </div>

          <div class="contrato-vazio" *ngIf="contratos.length === 0">
            <i class="fas fa-file-signature"></i>
            <span>Nenhum contrato encontrado para este cliente.</span>
          </div>
        </div>

        <div class="contrato-financeiro" *ngIf="contratoSelecionado">
          <div class="cf-header">
            <i class="fas fa-coins"></i>
            <span>Resumo Financeiro</span>
          </div>
          <div class="cf-grid">
            <div class="cf-item">
              <span class="cf-lbl">Valor Mensal</span>
              <span class="cf-val">{{
                fmtMoeda(contratoSelecionado.valorMensal)
              }}</span>
            </div>
            <div class="cf-item">
              <span class="cf-lbl">Início</span>
              <span class="cf-val">{{
                fmtDisplay(contratoSelecionado.inicioContrato)
              }}</span>
            </div>
            <div class="cf-item">
              <span class="cf-lbl">Término</span>
              <span class="cf-val">{{
                fmtDisplay(contratoSelecionado.fimContrato)
              }}</span>
            </div>
            <div class="cf-item" *ngIf="contratoSelecionado.numPostos">
              <span class="cf-lbl">Postos</span>
              <span class="cf-val">{{ contratoSelecionado.numPostos }}</span>
            </div>
          </div>
        </div>

        <span
          class="sp-error block mt-1"
          *ngIf="
            contratoForm.get('idContrato')?.invalid &&
            contratoForm.get('idContrato')?.touched
          "
        >
          Seleccione ou crie um contrato
        </span>

        <button
          class="btn-outline-primary mt-3"
          type="button"
          (click)="toggleNovoContrato()"
        >
          <i class="fas fa-plus"></i>
          {{ showNovoContrato ? "Cancelar" : "Novo Contrato" }}
        </button>

        <div
          class="novo-contrato-form"
          *ngIf="showNovoContrato"
          [formGroup]="novoContratoForm"
        >
          <p class="nc-section-title">
            <i class="fas fa-coins"></i> Condições Financeiras
          </p>
          <div class="form-group">
            <label>Tipo de Serviço *</label>
            <p-select
              formControlName="tipoServico"
              [options]="tiposServico"
              optionLabel="label"
              optionValue="value"
              placeholder="Seleccionar tipo de serviço"
              styleClass="w-full"
              appendTo="body"
            >
            </p-select>
            <span
              class="sp-error block"
              *ngIf="ncf['tipoServico'].invalid && ncf['tipoServico'].touched"
            >
              Campo obrigatório
            </span>
          </div>
          <div class="form-group">
            <label>Modelo de Cobrança *</label>
            <p-select formControlName="modeloCobranca" [options]="modeloCobrancas"
              optionLabel="label" optionValue="value" placeholder="Seleccionar modelo"
              styleClass="w-full" appendTo="body" (onChange)="onModeloChange($event)">
            </p-select>
          </div>

          <ng-container [ngSwitch]="modeloCobranca">
            <!-- FIXO MENSAL -->
            <ng-container *ngSwitchCase="'fixo_mensal'">
              <div class="nc-grid-2 nc-billing-fields">
                <div class="form-group">
                  <label>Valor Mensal (Kz) *</label>
                  <p-inputnumber
                    formControlName="valorMensal"
                    [min]="0"
                    [useGrouping]="true"
                    placeholder="Ex: 5 000 000"
                    styleClass="w-full"
                    suffix=" Kz"
                  >
                  </p-inputnumber>
                </div>
                <div class="form-group">
                  <label>Nº de Postos</label>
                  <p-inputnumber
                    formControlName="numPostos"
                    [min]="0"
                    styleClass="w-full"
                  >
                  </p-inputnumber>
                </div>
              </div>
              <div class="nc-finance-preview" *ngIf="(ncf['valorMensal'].value || 0) > 0">
                <div class="nc-fp-item">
                  <span class="nc-fp-lbl"><i class="fas fa-calendar-days"></i> Valor Mensal</span>
                  <span class="nc-fp-val">{{ fmtMoeda(ncf['valorMensal'].value) }}</span>
                </div>
                <div class="nc-fp-sep"></div>
                <div class="nc-fp-item">
                  <span class="nc-fp-lbl"><i class="fas fa-calendar-days"></i> Valor Anual Estimado</span>
                  <span class="nc-fp-val strong">{{ fmtMoeda((ncf['valorMensal'].value || 0) * 12) }}</span>
                </div>
              </div>
            </ng-container>

            <!-- POR EFETIVO -->
            <ng-container *ngSwitchCase="'por_efetivo'">
              <div class="nc-grid-2 nc-billing-fields">
                <div class="form-group">
                  <label>Valor unitário (Kz) *</label>
                  <p-inputnumber
                    formControlName="valorUnitario"
                    [min]="0"
                    [useGrouping]="true"
                    placeholder="Ex: 50 000"
                    styleClass="w-full"
                    suffix=" Kz"
                  >
                  </p-inputnumber>
                </div>
                <div class="form-group">
                  <label>Nº de efectivos *</label>
                  <p-inputnumber
                    formControlName="numEfetivos"
                    [min]="0"
                    styleClass="w-full"
                  >
                  </p-inputnumber>
                </div>
              </div>
              <div class="nc-finance-preview" *ngIf="totalMensalCalculado > 0">
                <div class="nc-fp-item">
                  <span class="nc-fp-lbl"><i class="fas fa-coins"></i> Total Mensal</span>
                  <span class="nc-fp-val strong">{{ fmtMoeda(totalMensalCalculado) }}</span>
                </div>
                <div class="nc-fp-sep"></div>
                <div class="nc-fp-item">
                  <span class="nc-fp-lbl"><i class="fas fa-calendar-days"></i> Valor Anual Estimado</span>
                  <span class="nc-fp-val">{{ fmtMoeda(totalMensalCalculado * 12) }}</span>
                </div>
              </div>
            </ng-container>

            <!-- POR POSTO -->
            <ng-container *ngSwitchCase="'por_posto'">
              <div class="nc-grid-2 nc-billing-fields">
                <div class="form-group">
                  <label>Valor unitário (Kz) *</label>
                  <p-inputnumber
                    formControlName="valorUnitario"
                    [min]="0"
                    [useGrouping]="true"
                    placeholder="Ex: 200 000"
                    styleClass="w-full"
                    suffix=" Kz"
                  >
                  </p-inputnumber>
                </div>
                <div class="form-group">
                  <label>Nº de postos *</label>
                  <p-inputnumber
                    formControlName="numPostos"
                    [min]="0"
                    styleClass="w-full"
                  >
                  </p-inputnumber>
                </div>
              </div>
              <div class="nc-finance-preview" *ngIf="totalMensalCalculado > 0">
                <div class="nc-fp-item">
                  <span class="nc-fp-lbl"><i class="fas fa-coins"></i> Total Mensal</span>
                  <span class="nc-fp-val strong">{{ fmtMoeda(totalMensalCalculado) }}</span>
                </div>
                <div class="nc-fp-sep"></div>
                <div class="nc-fp-item">
                  <span class="nc-fp-lbl"><i class="fas fa-calendar-days"></i> Valor Anual Estimado</span>
                  <span class="nc-fp-val">{{ fmtMoeda(totalMensalCalculado * 12) }}</span>
                </div>
              </div>
            </ng-container>

            <!-- POR HORA -->
            <ng-container *ngSwitchCase="'por_hora'">
              <div class="nc-grid-2 nc-billing-fields">
                <div class="form-group">
                  <label>Valor por hora (Kz) *</label>
                  <p-inputnumber
                    formControlName="valorUnitario"
                    [min]="0"
                    [useGrouping]="true"
                    placeholder="Ex: 5 000"
                    styleClass="w-full"
                    suffix=" Kz"
                  >
                  </p-inputnumber>
                </div>
                <div class="form-group">
                  <label>Nº de horas / mês *</label>
                  <p-inputnumber
                    formControlName="numHoras"
                    [min]="0"
                    styleClass="w-full"
                  >
                  </p-inputnumber>
                </div>
              </div>
              <div class="nc-finance-preview" *ngIf="totalMensalCalculado > 0">
                <div class="nc-fp-item">
                  <span class="nc-fp-lbl"><i class="fas fa-coins"></i> Total Mensal</span>
                  <span class="nc-fp-val strong">{{ fmtMoeda(totalMensalCalculado) }}</span>
                </div>
                <div class="nc-fp-sep"></div>
                <div class="nc-fp-item">
                  <span class="nc-fp-lbl"><i class="fas fa-calendar-days"></i> Valor Anual Estimado</span>
                  <span class="nc-fp-val">{{ fmtMoeda(totalMensalCalculado * 12) }}</span>
                </div>
              </div>
            </ng-container>
          </ng-container>

          <span
            class="sp-error block"
            *ngIf="
              novoContratoForm.hasError('modeloIncompleto') &&
              novoContratoForm.touched
            "
          >
            <i class="fas fa-triangle-exclamation"></i> Preencha correctamente os valores do modelo de cobrança seleccionado
          </span>

          <div class="nc-divider"></div>

          <p class="nc-section-title">
            <i class="fas fa-calendar-days"></i> Período do Contrato
          </p>
          <div class="nc-grid-3">
            <div class="form-group">
              <label>Data de Início *</label>
              <p-datepicker
                [showIcon]="true"
                formControlName="inicioContrato"
                dateFormat="dd/mm/yy"
                placeholder="dd/mm/aaaa"
                styleClass="w-full"
                appendTo="body"
                [autoZIndex]="true"
                [baseZIndex]="1000010"
                panelStyleClass="drawer-datepicker-panel"
              >
              </p-datepicker>
              <span
                class="sp-error"
                *ngIf="
                  ncf['inicioContrato'].invalid && ncf['inicioContrato'].touched
                "
              >
                <i class="fas fa-triangle-exclamation"></i> Obrigatório
              </span>
            </div>
            <div class="form-group">
              <label>Data de Fim *</label>
              <p-datepicker
                [showIcon]="true"
                formControlName="fimContrato"
                dateFormat="dd/mm/yy"
                placeholder="dd/mm/aaaa"
                styleClass="w-full"
                appendTo="body"
                [autoZIndex]="true"
                [baseZIndex]="1000010"
                panelStyleClass="drawer-datepicker-panel"
              >
              </p-datepicker>
              <span
                class="sp-error"
                *ngIf="ncf['fimContrato'].invalid && ncf['fimContrato'].touched"
              >
                <i class="fas fa-triangle-exclamation"></i> Obrigatório
              </span>
            </div>
            <div class="form-group">
              <label>Data de Facturação</label>
              <p-datepicker
                [showIcon]="true"
                formControlName="dataFaturacao"
                dateFormat="dd/mm/yy"
                placeholder="dd/mm/aaaa"
                styleClass="w-full"
                appendTo="body"
                [autoZIndex]="true"
                [baseZIndex]="1000010"
                panelStyleClass="drawer-datepicker-panel"
              >
              </p-datepicker>
            </div>
          </div>

          <span
            class="sp-error block mt-1"
            *ngIf="
              novoContratoForm.hasError('fimAnterior') &&
              ncf['fimContrato'].touched
            "
          >
            <i class="fas fa-triangle-exclamation"></i> A data de fim deve ser
            posterior à data de início
          </span>

          <div class="nc-duracao-pill" *ngIf="contratoDuracaoMeses > 0">
            <i class="fas fa-calendar-check"></i>
            Duração:
            <strong>
              {{ contratoDuracaoMeses }} mes{{
                contratoDuracaoMeses !== 1 ? "es" : ""
              }}
            </strong>
          </div>

          <div class="nc-divider"></div>

          <p class="nc-section-title">
            <i class="fas fa-file-contract"></i> Documento do Contrato
            <span class="nc-opt">*</span>
          </p>

          <input
            #contratoFileInput
            type="file"
            accept=".pdf,.doc,.docx,.xls,.xlsx,image/*"
            hidden
            (change)="onContratoFileChange($event)"
          />

          <div
            class="nc-upload-zone"
            (click)="triggerContratoFileInput()"
            [class.has-file]="contratoFile"
          >
            <ng-container *ngIf="!contratoFile">
              <div class="nc-uz-icon">
                <i class="fas fa-cloud-arrow-up"></i>
              </div>
              <div class="nc-uz-text">
                <span>Clique para anexar o documento</span>
                <small>PDF, Word, Excel ou imagem</small>
              </div>
            </ng-container>
            <ng-container *ngIf="contratoFile">
              <div class="nc-uz-icon file">
                <i class="fas fa-file-circle-check"></i>
              </div>
              <div class="nc-uz-text">
                <span>{{ contratoFile.name }}</span>
                <small>{{ contratoFile.size | number }} bytes</small>
              </div>
              <button
                type="button"
                class="nc-uz-remove"
                (click)="removeContratoFile($event)"
              >
                <i class="fas fa-xmark"></i>
              </button>
            </ng-container>
          </div>
          <span class="sp-error block mt-1" *ngIf="contratoFileRequiredError">
            <i class="fas fa-triangle-exclamation"></i> Documento do contrato obrigatório
          </span>

          <div class="nc-actions">
            <button
              class="btn-web-primary"
              type="button"
              (click)="criarContrato()"
            >
              <i class="fas fa-floppy-disk"></i> Guardar Contrato
            </button>
          </div>
        </div>
      </div>

      <!-- PASSO 2: DADOS DO POSTO -->
      <div *ngIf="activeStep === 2" class="step-panel" [formGroup]="postoForm">
        <div class="step-header">
          <div class="step-icon"><i class="fas fa-map-marker-alt"></i></div>
          <div>
            <h2>Dados do Posto</h2>
            <p>Identificação e configuração operacional</p>
          </div>
        </div>

        <p class="section-title">Identificação</p>
        
        <div class="form-group">
          <label>Designação *</label>
          <input
            class="form-input"
            formControlName="nome"
            placeholder="Nome do posto"
          />
          <span
            class="sp-error"
            *ngIf="
              postoForm.get('nome')?.invalid && postoForm.get('nome')?.touched
            "
          >
            Campo obrigatório (mín. 3 caracteres)
          </span>
        </div>

        <div class="form-grid-2">
          <div class="form-group">
            <label>Tipo de Posto *</label>
            <p-select
              formControlName="idTipoPosto"
              [options]="tiposPostos"
              optionLabel="designacao"
              optionValue="id"
              placeholder="Seleccionar tipo"
              [loading]="loadingDropdowns"
              styleClass="w-full"
              appendTo="body"
            >
            </p-select>
            <span
              class="sp-error"
              *ngIf="
                postoForm.get('idTipoPosto')?.invalid &&
                postoForm.get('idTipoPosto')?.touched
              "
            >
              Campo obrigatório
            </span>
          </div>

          <div class="form-group">
            <label>Província *</label>
            <p-select
              [(ngModel)]="selectedProvinciaId"
              [ngModelOptions]="{ standalone: true }"
              [options]="provincias"
              optionLabel="designacao"
              optionValue="id"
              placeholder="Seleccionar província"
              [loading]="loadingDropdowns"
              [showClear]="true"
              styleClass="w-full"
              appendTo="body"
              (onChange)="onProvinciaChange($event.value)"
            >
            </p-select>
          </div>
        </div>

        <!-- ENDEREÇO E MUNICÍPIO NA MESMA LINHA -->
        <div class="form-grid-2">
          <div class="form-group">
            <label>Endereço</label>
            <input
              class="form-input"
              formControlName="endereco"
              placeholder="Rua, número, bairro…"
            />
          </div>

          <div class="form-group">
            <label>Município *</label>
            <p-select
              formControlName="idMunicipio"
              [options]="municipiosFiltrados"
              optionLabel="designacao"
              optionValue="id"
              [placeholder]="
                selectedProvinciaId || municipiosFiltrados.length
                  ? 'Seleccionar município'
                  : 'Seleccione primeiro a província'
              "
              [loading]="loadingMunicipios"
              [disabled]="
                !selectedProvinciaId && municipiosFiltrados.length === 0
              "
              [filter]="true"
              styleClass="w-full"
              appendTo="body"
            >
            </p-select>
            <span
              class="sp-error"
              *ngIf="
                postoForm.get('idMunicipio')?.invalid &&
                postoForm.get('idMunicipio')?.touched
              "
            >
              Campo obrigatório
            </span>
          </div>
        </div>

        <div class="form-group">
          <label>Instruções Especiais</label>
          <textarea
            pTextarea
            class="form-input"
            formControlName="instrucoesEspeciais"
            rows="3"
            placeholder="Instruções para os efetivos, verificações, acessos especiais…"
          ></textarea>
        </div>

        <p class="section-title">
          <i class="pi pi-box"></i> Tipos de Equipamentos
        </p>
        <p class="section-hint">
          Seleccione os tipos necessários e defina a quantidade de cada um
        </p>

        <div *ngIf="loadingEquip" class="equip-loading">
          <i class="fas fa-spinner fa-spin"></i> A carregar tipos de equipamentos…
        </div>

        <div
          class="tipo-equip-grid"
          *ngIf="!loadingEquip && tiposEquipamento.length > 0"
        >
          <article
            class="tipo-equip-card"
            *ngFor="let tipo of tiposEquipamento"
            [class.selected]="isTipoEquipamentoSelecionado(tipo.id)"
          >
            <button
              type="button"
              class="tipo-equip-toggle"
              (click)="toggleTipoEquipamento(tipo)"
              [attr.aria-pressed]="isTipoEquipamentoSelecionado(tipo.id)"
            >
              <span class="tipo-equip-icon">
                <i [class]="getEquipIcon(tipo)"></i>
              </span>
              <span class="tipo-equip-info">
                <strong>{{ tipo.designacao.trim() }}</strong>
                <small>{{ tipo.nomeCategoria || "Tipo de equipamento" }}</small>
              </span>
              <span class="tipo-equip-check">
                <i
                  [class]="
                    isTipoEquipamentoSelecionado(tipo.id)
                      ? 'pi pi-check'
                      : 'pi pi-plus'
                  "
                ></i>
              </span>
            </button>

            <div
              class="tipo-equip-quantity"
              *ngIf="
                getTipoEquipamentoSelecionado(tipo.id) as equipamentoSelecionado
              "
            >
              <span>Quantidade</span>
              <div class="quantity-stepper">
                <button
                  type="button"
                  (click)="
                    decrementarEquipamento(
                      equipamentoSelecionado.idTipoEquipamento
                    )
                  "
                  [disabled]="equipamentoSelecionado.quantidade <= 1"
                  aria-label="Diminuir quantidade"
                >
                  <i class="pi pi-minus"></i>
                </button>
                <input
                  type="number"
                  min="1"
                  [ngModel]="equipamentoSelecionado.quantidade"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="
                    updateEquipamentoQuantidade(
                      equipamentoSelecionado.idTipoEquipamento,
                      $event
                    )
                  "
                />
                <button
                  type="button"
                  (click)="
                    incrementarEquipamento(
                      equipamentoSelecionado.idTipoEquipamento
                    )
                  "
                  aria-label="Aumentar quantidade"
                >
                  <i class="pi pi-plus"></i>
                </button>
              </div>
            </div>
          </article>
        </div>

        <div
          class="equip-vazio"
          *ngIf="!loadingEquip && tiposEquipamento.length === 0"
        >
          <i class="fas fa-toolbox"></i>
          <div>
            <span>Sem tipos de equipamentos disponíveis</span>
            <small>Adicione tipos no módulo de Equipamentos</small>
          </div>
        </div>

        <div class="equip-counter" *ngIf="listaEquipamentos.length > 0">
          <i class="pi pi-check-circle"></i>
          {{ listaEquipamentos.length }} tipo(s) seleccionado(s) ·
          {{ totalEquipamentosNecessarios }} unidade(s)
        </div>

        <p class="section-title" style="margin-top: 1.5rem">
          <i class="fas fa-sliders"></i> Configuração Operacional
        </p>

        <div class="form-group">
          <label>Nível de Risco *</label>
          <div class="risco-buttons">
            <button
              type="button"
              class="risco-btn"
              *ngFor="let opt of riscosOptions"
              [class.active]="postoForm.get('risco')?.value === opt.value"
              [style.--risco-color]="opt.color"
              (click)="postoForm.get('risco')?.setValue(opt.value)"
            >
              <i [class]="opt.icon"></i>
              {{ opt.label }}
            </button>
          </div>
        </div>

        <div class="operacao-grid">
          <div class="operacao-card">
            <div class="op-icon"><i class="fas fa-users"></i></div>
            <div class="op-body">
              <span class="op-label">Efetivos por Turno</span>
              <p-inputnumber
                formControlName="numEfetivosturno"
                [min]="1"
                [max]="100"
                [showButtons]="true"
                styleClass="w-full"
              >
              </p-inputnumber>
            </div>
          </div>
          <div class="operacao-card">
            <div class="op-icon"><i class="fas fa-clock"></i></div>
            <div class="op-body">
              <span class="op-label">Turnos por Dia</span>
              <p-inputnumber
                formControlName="numTurnosDia"
                [min]="1"
                [max]="4"
                [showButtons]="true"
                styleClass="w-full"
              >
              </p-inputnumber>
            </div>
          </div>
          <div class="operacao-card op-preview">
            <div class="op-icon purple"><i class="fas fa-calculator"></i></div>
            <div class="op-body">
              <span class="op-label">Total Efetivos / Dia</span>
              <span class="op-calc">
                {{
                  (postoForm.get("numEfetivosturno")?.value ?? 1) *
                    (postoForm.get("numTurnosDia")?.value ?? 1)
                }}
                <span class="op-calc-sub">ef. por dia</span>
              </span>
            </div>
          </div>
        </div>

        <p class="section-title" style="margin-top: 1.5rem">
          <i class="fas fa-map-pin"></i> Coordenadas GPS e Localização
        </p>
        <p class="section-hint">
          Clique diretamente em qualquer ponto do mapa para extrair a latitude e
          longitude automaticamente
        </p>

        <div class="localizacao-grid">
          <div class="form-group">
            <label>Latitude</label>
            <input
              type="number"
              class="form-input"
              formControlName="latitude"
              placeholder="-8.838333"
              step="0.000001"
              (input)="onCoordsChange()"
            />
          </div>
          <div class="form-group">
            <label>Longitude</label>
            <input
              type="number"
              class="form-input"
              formControlName="longitude"
              placeholder="13.234444"
              step="0.000001"
              (input)="onCoordsChange()"
            />
          </div>

          <button
            type="button"
            class="btn-outline-primary gps-btn"
            (click)="usarLocalizacaoActual()"
          >
            <i class="fas fa-crosshairs"></i> Usar localização actual
          </button>

          <div class="mapa-preview-wrap mt-3" style="grid-column: span 2">
            <div id="mapa-interativo" class="mapa-interativo-container"></div>
          </div>
        </div>
      </div>

      <!-- PASSO 3: REVISÃO -->
      <div *ngIf="activeStep === 3" class="step-panel">
        <div class="step-header">
          <div class="step-icon"><i class="fas fa-eye"></i></div>
          <div>
            <h2>Revisão</h2>
            <p>
              {{
                editMode
                  ? "Confirme os dados antes de guardar as alterações"
                  : "Confirme os dados antes de criar o posto"
              }}
            </p>
          </div>
        </div>

        <div class="review-sections">
          <div class="review-section">
            <div class="review-section-header">
              <span class="rs-label">CLIENTE</span>
              <button class="btn-edit" type="button" (click)="goToStep(0)">
                <i class="fas fa-pen"></i> Editar
              </button>
            </div>
            <div class="rs-body">
              <span class="rs-main">{{ clienteSelecionado?.nome }}</span>
              <span class="rs-sub" *ngIf="clienteSelecionado?.nif"
                >NIF: {{ clienteSelecionado?.nif }}</span
              >
            </div>
          </div>

          <div class="review-section">
            <div class="review-section-header">
              <span class="rs-label">CONTRATO</span>
              <button class="btn-edit" type="button" (click)="goToStep(1)">
                <i class="fas fa-pen"></i> Editar
              </button>
            </div>
            <div class="rs-body">
              <span class="rs-main">{{ contratoLabel }}</span>
              <span class="rs-sub" *ngIf="contratoSelecionado"
                >{{ fmtMoeda(contratoSelecionado.valorMensal) }}/mês</span
              >
            </div>
          </div>

          <div class="review-section">
            <div class="review-section-header">
              <span class="rs-label">POSTO</span>
              <button class="btn-edit" type="button" (click)="goToStep(2)">
                <i class="fas fa-pen"></i> Editar
              </button>
            </div>
            <div class="rs-body">
              <span class="rs-main"
                >{{ postoForm.get("nome")?.value }} · {{ tipoPostoNome }}</span
              >
              <span class="rs-sub">
                {{ municipioNome
                }}<span *ngIf="postoForm.get('endereco')?.value"
                  >, {{ postoForm.get("endereco")?.value }}</span
                >
              </span>
              <div class="rs-tags">
                <span
                  class="rs-tag"
                  [attr.data-risco]="postoForm.get('risco')?.value"
                >
                  Risco: {{ postoForm.get("risco")?.value }}
                </span>
                <span class="rs-tag neutral"
                  >{{ postoForm.get("numEfetivosturno")?.value }} ef/turno</span
                >
                <span class="rs-tag neutral"
                  >{{ postoForm.get("numTurnosDia")?.value }} turnos/dia</span
                >
              </div>
            </div>
          </div>

          <div
            class="review-section"
            *ngIf="postoForm.get('instrucoesEspeciais')?.value"
          >
            <div class="review-section-header">
              <span class="rs-label">INSTRUÇÕES</span>
              <button class="btn-edit" type="button" (click)="goToStep(2)">
                <i class="fas fa-pen"></i> Editar
              </button>
            </div>
            <div class="rs-body">
              <p class="rs-instrucoes">
                "{{ postoForm.get("instrucoesEspeciais")?.value }}"
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- FOOTER -->
      <div class="wizard-footer">
        <button
          class="btn-web-secondary"
          type="button"
          *ngIf="activeStep > 0"
          (click)="prevStep()"
        >
          <i class="fas fa-arrow-left"></i> Anterior
        </button>
        <button
          class="btn-web-secondary"
          type="button"
          *ngIf="activeStep === 0"
          (click)="cancel()"
        >
          Cancelar
        </button>
        <button
          class="btn-web-primary"
          type="button"
          *ngIf="activeStep < 3"
          (click)="nextStep()"
        >
          Próximo <i class="fas fa-arrow-right"></i>
        </button>
        <button
          class="btn-primary btn-criar"
          type="button"
          *ngIf="activeStep === 3"
          [disabled]="submitting"
          (click)="onSubmit()"
        >
          <i class="fas fa-spinner fa-spin" *ngIf="submitting"></i>
          <i class="fas fa-map-pin" *ngIf="!submitting && !editMode"></i>
          <i class="fas fa-floppy-disk" *ngIf="!submitting && editMode"></i>
          {{
            submitting
              ? editMode
                ? "A guardar…"
                : "A criar…"
              : editMode
                ? "Guardar Alterações"
                : "Criar Posto"
          }}
        </button>
      </div>
    </main>
  </div>
</div>
